import { useState, useCallback } from 'react';
export function useToast() {
  const [toasts, setToasts] = useState([]);
  const add = useCallback((message, type='info', ms=3500) => {
    const id = Date.now()+Math.random();
    setToasts(t => [...t,{id,message,type}]);
    setTimeout(()=>setToasts(t=>t.filter(x=>x.id!==id)), ms);
  }, []);
  // Memoizadas para que no cambien referencia en cada render
  const success = useCallback((m) => add(m, 'success'), [add]);
  const error   = useCallback((m) => add(m, 'error'),   [add]);
  const info    = useCallback((m) => add(m, 'info'),    [add]);
  return { toasts, success, error, info };
}
